"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ProductList;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _productIcon = _interopRequireDefault(require("../product-icon"));
var _react2 = require("@linaria/react");
var _density = require("@site/pattern-library-utils/density");
const List = /*#__PURE__*/(0, _react2.styled)("ul")({
  name: "List",
  class: "pl-l7dxshz"
});
const ListItem = /*#__PURE__*/(0, _react2.styled)("li")({
  name: "ListItem",
  class: "pl-l1mkcqe"
});

/**
 * @memberof module:ProductListingSection
 *
 * @param {object} items list items
 * @param {string} dataCy data-cy attribute
 * @returns {React.ReactElement} Product List
 */
function ProductList({
  items,
  dataCy = 'product-list'
}) {
  if (!items) {
    return null;
  }

  // TODO: Update border radius to use intents.
  return /*#__PURE__*/_react.default.createElement(List, {
    "data-cy": dataCy
  }, items?.slice(0, 6).map((item, i) => /*#__PURE__*/_react.default.createElement(ListItem, {
    key: i
  }, /*#__PURE__*/_react.default.createElement(_productIcon.default, (0, _extends2.default)({}, item.productIcon, {
    width: _density.density['7'],
    height: _density.density['7'],
    borderRadius: _density.density['2']
  })), item.text)));
}
ProductList.propTypes = {
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    productIcon: _propTypes.default.shape(_productIcon.default.propTypes),
    text: _propTypes.default.string
  })),
  dataCy: _propTypes.default.string
};